import { supabase } from "@/integrations/supabase/client";

export interface ResumeData {
  Name: string;
  Phone: string;
  Email: string;
  City: string;
  State: string;
  LinkedIn: string;
  Summary: string;
  Skills: Array<{ Skill: string }>;
  CareerHighlights: Array<{ chtitle: string; chdescription: string }>;
  ProfessionalExperience: Array<{
    job_title: string;
    company: string;
    location: string;
    start_date: string;
    end_date: string;
    Descriptions: Array<{ Description: string }>;
  }>;
  CertificationsAndLicenses: Array<{
    Certification_or_License_Name: string;
    Institution_Organization: string;
    Year: string;
  }>;
  TechnicalSkills: any[];
  Languages: any[];
  AwardsAndHonors: Array<{
    Award_Name: string;
    Institution_Organization: string;
    Year: string;
  }>;
  ProfessionalAffiliations: any[];
  Publications: any[];
  Projects: any[];
  Presentations: any[];
  Portfolio: any[];
  TrainingAndDevelopment: any[];
  MilitaryExperience: any[];
  VolunteerMemberships: any[];
  Education: Array<{
    College_Degree_Name: string;
    Major: string;
    College_Name: string;
    City: string;
    ST: string;
    Year_Earned: string;
  }>;
}

export class ResumeDocmosisService {
  static async generateResume(data: ResumeData): Promise<Blob> {
    try {
      console.log('Generating resume:', {
        hasData: !!data,
        name: data.Name
      });

      const response = await fetch(`https://gxatnnzwaggcvzzurgsq.supabase.co/functions/v1/generate-resume`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imd4YXRubnp3YWdnY3Z6enVyZ3NxIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTI2MTQzMzMsImV4cCI6MjA2ODE5MDMzM30.btK3YXr_f0uPm_mwT5q9-8U3d10_QMevDSlC2NSZO_I`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ resumeData: data })
      });

      if (!response.ok) {
        const errorText = await response.text();
        console.error('Error calling generate-resume function:', errorText);
        throw new Error(`Resume generation failed: ${response.status} - ${errorText}`);
      }

      // Return the response as a blob
      return await response.blob();

    } catch (error) {
      console.error('Error in ResumeDocmosisService.generateResume:', error);
      throw new Error(
        error instanceof Error 
          ? error.message 
          : 'Failed to generate resume'
      );
    }
  }

  static downloadBlob(blob: Blob, filename: string): void {
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  }
}